import React, { useEffect, useState } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";

import "./Navigation.scss";

import {
  getInitialLocale,
  type SupportedLocale,
} from "../../utils/i18n";



interface NavigationItem {

  title: string;

  slug: string;

  type: string;

}



interface NavigationGroup {

  title: string;

  order: number;

  items: NavigationItem[];

}



export default function Navigation() {


  const [locale, setLocale] =
    useState<SupportedLocale>("it");


  const [openMenu, setOpenMenu] =
    useState<string | null>(null);



  useEffect(() => {

    setLocale(getInitialLocale());

  }, []);




  const data = useStaticQuery(graphql`

    query DynamicNavigationQuery {

      allMarkdownRemark {

        nodes {

          frontmatter {

            locale

            title

            slug

            type

            menuTitle

            menuOrder

            showInMenu

          }

        }

      }

    }

  `);



  const contents =

    data.allMarkdownRemark.nodes

      .filter((node:any)=>{

        return (

          node.frontmatter.locale === locale &&

          node.frontmatter.showInMenu === true

        );

      })

      .map((node:any)=>node.frontmatter);




  const groups: NavigationGroup[] = [];



  contents.forEach((item:any)=>{


    const existing =

      groups.find(

        group =>
          group.title === item.menuTitle

      );



    if(existing){


      existing.items.push({

        title:item.title,

        slug:item.slug,

        type:item.type

      });


    }

    else{


      groups.push({

        title:item.menuTitle,

        order:item.menuOrder ?? 99,

        items:[

          {

            title:item.title,

            slug:item.slug,

            type:item.type

          }

        ]

      });


    }


  });




  groups.sort(

    (a,b)=>

      a.order - b.order

  );





  return (

    <nav className="nav">


      <div className="container">


        <ul className="navList">


          {groups.map(group=>(


            <li

              key={group.title}

              className="navItem"


              onMouseEnter={()=>

                setOpenMenu(group.title)

              }


              onMouseLeave={()=>

                setOpenMenu(null)

              }

            >


              <button

                className="navButton"

                type="button"

              >

                {group.title}


                {group.items.length > 0 && (

                  <span className="arrow">
                    ▾
                  </span>

                )}

              </button>




              {openMenu === group.title && (

                <div className="submenu">


                  {group.items.map(item=>(


                    <Link

                      key={item.slug}

                      to={`/${locale}/${item.slug}`}

                      className="submenuItem"

                    >

                      {item.title}

                    </Link>


                  ))}


                </div>

              )}


            </li>


          ))}


        </ul>


      </div>


    </nav>

  );

}